import { create } from "zustand";
import { getFilterManualFlareVolume, searchManualFlareVolume, updateManualFlareVolume } from "src/services/flare.service";
import { ManualFlareVolumeStoreProps } from "./interface/manual-flare-store.interface";
import {
  FilterManualFlareVolume,
  OriginResponseManualFlareVolume,
  UpdateManualFlareVolume,
} from "src/entity/flare/manual-flare-volume.entity";
import { omit } from "lodash";
import { FlareCaseEnum } from "src/entity/flare/flare.constants";

const getInitialFilter = () => ({
  sourceName: [],
  gasName: [],
  area: [],
  flareName: [],
});

export const manualFlareStore = create<ManualFlareVolumeStoreProps>((set) => ({
  loadingAll: false,
  loadingManage: false,
  loadingGet: false,
  dataManual: {
    total: 0,
    data: [],
  },
  filterManualFlareVolume: {
    sourceName: [],
    gasName: [],
    area: [],
    flareName: [],
  },
  loadingGetMaster: false,
  error: null,
  clearError: (type: string) => {
    set(() => ({ [`${type}`]: null }));
  },
  setLoadingAll: (loading: boolean) => {
    set(() => ({ loadingAll: loading }));
  },
  searchManualFlareVolume: async (filter: FilterManualFlareVolume) => {
    set(() => ({ loadingGet: true }));
    try {
      const res = await searchManualFlareVolume(filter);
      const rawData = res?.data?.data;

      const transformArray: any = [];
      rawData.data.forEach((item: any, index: number) => {
        const turnaround = item.flareVolume.find((e: any) => e.flareCase === FlareCaseEnum.TURNAROUND);
        const emergency = item.flareVolume.find((e: any) => e.flareCase === FlareCaseEnum.EMERGENCY);
        const normalOperate = item.flareVolume.find((e: any) => e.flareCase === FlareCaseEnum.NORMAL_OPERATE);
        transformArray.push({
          ...omit(item, ["flareVolume"]),
          no: index + 1,
          flareCase: FlareCaseEnum.NORMAL_OPERATE,
          flareVolumeMonthly: normalOperate,
        });
        transformArray.push({
          ...omit(item, ["flareVolume"]),
          no: index + 1,
          flareCase: FlareCaseEnum.TURNAROUND,
          flareVolumeMonthly: turnaround,
        });
        transformArray.push({
          ...omit(item, ["flareVolume"]),
          no: index + 1,
          flareCase: FlareCaseEnum.EMERGENCY,
          flareVolumeMonthly: emergency,
        });
      });
      rawData.data = transformArray;
      // console.log("Raw manual data : ", rawData);
      set(() => ({ loadingGet: false, dataManual: rawData }));
    } catch (err: any) {
      set(() => ({ loadingGet: false, error: err?.message, dataManual: { data: [], total: 0 } }));
    }
  },
  updateManualFlareVolume: async (body: UpdateManualFlareVolume) => {
    set(() => ({ loadingManage: true }));
    try {
      await updateManualFlareVolume(body);
      set(() => ({ loadingManage: false }));
    } catch (err: any) {
      const message = err?.response?.data?.message || err?.message;
      set(() => ({ loadingManage: false, error: message }));
      return message;
    }
  },
  getFilterManualFlareVolume: async (year: string) => {
    set(() => ({ loadingGetMaster: true }));
    try {
      const res = await getFilterManualFlareVolume({ year });
      set(() => ({
        loadingGetMaster: false,
        filterManualFlareVolume: res.data?.data,
      }));
    } catch (err: any) {
      set(() => ({
        loadingGetMaster: false,
        filterManualFlareVolume: getInitialFilter(),
      }));
    }
  },
}));
